export class SaveHostLanguagesCommand {
  languages: string[];
  constructor(languages: string[]) {
    this.languages = languages;
  }
}
